import { Box, Text } from '@chakra-ui/react';

export const IconButtonsPreview = () => {
  return (
    <Box>
      <Text>IconButtonsPreview - Coming soon</Text>
    </Box>
  );
};
